(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["brizeeo-product"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('brizeeo-product')) {
    customElements.define(
      'brizeeo-product',
      class extends HTMLElement {
        connectedCallback() {
          this.variants = JSON.parse(this.querySelector('[data-product-variants]')?.textContent || '[]');
          this.selectedOptions = [];
          this.querySelectorAll('[data-option-group]').forEach((group, index) => {
            const selected = group.querySelector('.is-selected');
            this.selectedOptions[index] = selected?.dataset.optionValue || '';
          });

          this.querySelectorAll('[data-option-value]').forEach((button) => {
            button.addEventListener('click', () => this.selectOption(button));
          });

          this.querySelectorAll('[data-thumbnail]').forEach((button) => {
            button.addEventListener('click', () => this.showMedia(Number(button.dataset.thumbnail)));
          });

          const track = this.querySelector('[data-gallery-track]');
          track?.addEventListener('scroll', () => {
            const index = Math.round(track.scrollLeft / track.clientWidth);
            this.setActiveThumb(index);
          }, { passive: true });
        }

        selectOption(button) {
          const index = Number(button.dataset.optionIndex);
          this.selectedOptions[index] = button.dataset.optionValue;
          this.querySelectorAll(`[data-option-index="${index}"]`).forEach((item) => {
            const selected = item === button;
            item.classList.toggle('is-selected', selected);
            item.setAttribute('aria-pressed', String(selected));
          });
          const label = this.querySelector(`[data-option-label="${index}"]`);
          if (label) label.textContent = button.dataset.optionValue;
          this.updateVariant();
        }

        updateVariant() {
          const variant = this.variants.find((item) =>
            item.options.every((value, index) => value === this.selectedOptions[index])
          );
          const input = this.querySelector('[data-variant-input]');
          const addButton = this.querySelector('[ref="addToCartButton"]');
          const addText = this.querySelector('[data-add-text]');
          const availability = this.querySelector('[data-availability]');

          if (!variant) {
            addButton.disabled = true;
            addText.textContent = this.dataset.labelUnavailable;
            availability.textContent = this.dataset.labelUnavailable;
            availability.classList.add('is-unavailable');
            return;
          }

          input.value = variant.id;
          input.dispatchEvent(new Event('change', { bubbles: true }));
          addButton.disabled = !variant.available;
          addText.textContent = variant.available ? this.dataset.labelAdd : this.dataset.labelSoldOut;
          availability.textContent = variant.available ? this.dataset.labelAvailable : this.dataset.labelSoldOut;
          availability.classList.toggle('is-unavailable', !variant.available);
          this.querySelector('[data-price]').textContent = this.formatMoney(variant.price);

          const compare = this.querySelector('[data-compare-price]');
          if (variant.compare_at_price && variant.compare_at_price > variant.price) {
            compare.hidden = false;
            compare.textContent = this.formatMoney(variant.compare_at_price);
          } else {
            compare.hidden = true;
          }

          if (variant.featured_media?.id) {
            const slides = [...this.querySelectorAll('[data-media-id]')];
            const index = slides.findIndex((slide) => Number(slide.dataset.mediaId) === variant.featured_media.id);
            if (index >= 0) this.showMedia(index);
          }

          const url = new URL(window.location.href);
          url.searchParams.set('variant', variant.id);
          window.history.replaceState({}, '', url);
        }

        showMedia(index) {
          const track = this.querySelector('[data-gallery-track]');
          const slide = track?.children[index];
          slide?.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
          this.setActiveThumb(index);
        }

        setActiveThumb(index) {
          this.querySelectorAll('[data-thumbnail]').forEach((thumb, thumbIndex) => {
            thumb.classList.toggle('is-active', thumbIndex === index);
          });
        }

        formatMoney(cents) {
          return new Intl.NumberFormat(document.documentElement.lang || 'fr-FR', {
            style: 'currency',
            currency: this.dataset.currency || 'EUR'
          }).format(cents / 100);
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
